import { SxProps, Theme, Typography, TypographyProps } from '@mui/material';

/** Line height used by AppCardTitle (tighter than theme subtitle1). */
export const APP_CARD_TITLE_LINE_HEIGHT = 1.2;
/** Max lines shown before ellipsis. */
export const APP_CARD_TITLE_LINE_CLAMP = 2;
/** Fixed height reserved for the title block (lineHeight × clamp). */
export const APP_CARD_TITLE_HEIGHT = `${APP_CARD_TITLE_LINE_HEIGHT * APP_CARD_TITLE_LINE_CLAMP}em`;

interface AppCardTitleProps {
  title: string;
  /** Typography variant; defaults to subtitle1. Use body2 for denser grids. */
  variant?: TypographyProps['variant'];
  sx?: SxProps<Theme>;
}

/**
 * Card title clamped to two lines with a fixed height so short and long titles
 * keep a consistent card layout. Full text is available via the native title tooltip.
 */
export function AppCardTitle({ title, variant = 'subtitle1', sx }: AppCardTitleProps) {
  return (
    <Typography
      variant={variant}
      component="h3"
      title={title}
      sx={{
        lineHeight: APP_CARD_TITLE_LINE_HEIGHT,
        // Reserve two lines even for short titles (lineHeight * clamp).
        height: APP_CARD_TITLE_HEIGHT,
        display: '-webkit-box',
        WebkitLineClamp: APP_CARD_TITLE_LINE_CLAMP,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        ...sx,
      }}
    >
      {title}
    </Typography>
  );
}
